export default "__VITE_ASSET__M1z43RQQ__"